if(!customElements.get('collection-filters')) {
  class CollectionFilters extends HTMLElement {
    constructor() { 
      super();
      // Internal Elements
      this.opener = this.querySelector('.js-filter-opener');
      this.body = this.querySelector('.js-filter-body');
      // External Elements
      this.grid = document.querySelector('collection-grid');
      this.counters = document.querySelectorAll('.js-filter-count');
      this.gridLoad = document.querySelector('.js-grid-load');
    }

    /**
     * setBodyFixed - Disables scroll on the <body> element
     */

    setBodyFixed() {
      this.scrollPosition = window.scrollY;
  
      document.body.classList.add('no-scroll');
      document.body.style.top = `-${this.scrollPosition}px`;
    }

    /**
     * removeBodyFixed - Enables scroll on the <body> element. 
     */
  
    removeBodyFixed() {
      document.body.classList.remove('no-scroll');
      document.body.style.removeProperty('top');
  
      if (this.scrollPosition) {
        window.scrollTo(0, this.scrollPosition);
      }
    }

    /**
     * initOpener - initializes the opener button (<a>) element. Expanding / Shrinikng the grid is desktop only
     */

    initOpener() {
      if(!this.opener || !this.body) return;
      
      this.opener.addEventListener('click', (event) => {
        event.preventDefault();

        this.body.classList.toggle('is-open');
        if(window.innerWidth < 989) {
          if(this.body.classList.contains('is-open')) return this.setBodyFixed();
          return this.removeBodyFixed();
        }
      
        if(this.body.classList.contains('is-open')) return this.grid.shrink(this.body);
        this.grid.expand();
      });
    }

    /**
     * initCounters - Initializes the counter elements
     */

    initCounters() {
      setTimeout(function(e){
        var length = $('.redemption .grid__inner.js-grid-inner .grid__inner-item').length;
        $('.redemption .js-filter-count').html('');
        $('.redemption .js-filter-count').html(length+' Result');    
      },2000);
      let count = this.grid.querySelectorAll('.grid__inner-item').length;
      
      if(this.gridLoad) count = this.gridLoad.dataset.totalItems;
      setTimeout(function(e){
        $('.redemption .js-filter-count').html(count+' Result');    
      },2000);
      this.counters.forEach((counter) => {
        // If count is 1 returns 'Result' instead of 'Results' or an empty string if the data-result/s are missing
        counter.innerHTML = `${count} ${count > 1 ? counter.dataset?.results ?? '' : counter.dataset?.result ?? ''}`.trim();
        counter.classList.remove('hidden');
      });
    }

    /**
     * processInputs - Fetches the filters that exist in the variant metafields of the current collection's products. And sends them to the FilterBlock component to remove the disabled attribute 
     */

    processInputs() {
      const url = new URL(window.location.href.split('?')[0]);
      const params = window.location.href.split('?')[1];

      url.searchParams.set('view', 'current-filters');

      if(params) params.split('&').forEach(param => {
        const [key, value] = param.split('=');
        url.searchParams.set(key, value);
      });

      fetch(url.toString())
        .then(res => res.text())
        .then(text => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const filters = html.getElementById('filters');
          if(!filters) return;
          const values = JSON.parse(filters.innerText);
          
          for (const key in values) {
            const block = this.querySelector(`.js-filter-block[data-key="${key}"]`);
   
            if(block) block.updateInputs(values[key]);
          }

          this.initCounters();
        })
        .catch(err => { console.error(err); });
    }

    closeFilters() {
      this.body.classList.remove('is-open');
      this.removeBodyFixed();
    }

    connectedCallback() {
      this.initOpener();
      this.initCounters();
      this.processInputs();
      
      this.querySelectorAll('.js-filters-body-close').forEach(button => {
        button.addEventListener('click', () => {
          this.closeFilters();
        });
      });
    }
  }

  customElements.define('collection-filters', CollectionFilters);
}


